"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const executor_1 = require("./executor");
const Logger_1 = require("./Logger");
const MemStore_1 = require("./MemStore");
const types_1 = require("./types");
class Extras {
    constructor() {
        this.role = '';
        this.mode = '';
        this.commentsEnabled = true;
        this.executorStatus = executor_1.ExecutorStatus.NotLoaded;
        this.accumilatedProhibition = 0;
        this.timeoutHandlers = {};
        this.bfIds = new Set();
        this.store = new MemStore_1.MemStore();
        this.onLoggerEmit = null;
        this.onActionEmit = null;
        this.logger = new Logger_1.Logger();
    }
    isBfIDValid(id) {
        if (this.bfIds.has(id)) {
            return false;
        }
        this.bfIds.add(id);
        return true;
    }
    lessonComplete() {
        // perform clean up after lesson complete
        this.executorStatus = executor_1.ExecutorStatus.LessonCompleted;
        this.doControlEmit(types_1.ControlActions.LessonComplete);
    }
    reset() {
        this.resetProhibition();
        this.store.reset();
        this.role = '';
        this.mode = '';
        this.bfIds = new Set();
        this.logger.reset();
        Object.values(this.timeoutHandlers).forEach((handler) => {
            clearTimeout(handler);
        });
    }
    resetProhibition() {
        this.accumilatedProhibition = 0;
    }
    getProhibition() {
        return this.accumilatedProhibition;
    }
    addProhibition(delta) {
        this.accumilatedProhibition += delta;
    }
    registerHandler(handler, nodeRefId) {
        if (this.timeoutHandlers[nodeRefId]) {
            clearTimeout(this.timeoutHandlers[nodeRefId]);
        }
        this.timeoutHandlers[nodeRefId] = handler;
    }
    doEmitDelay(delay) {
        this.doControlEmit(types_1.ControlActions.Delay, {
            delay,
        });
    }
    doEmit(payload) {
        if (this.onActionEmit !== null) {
            this.onActionEmit(payload);
            // this.logger.doLog(LogLevel.LESSON, payload);
        }
    }
    doControlEmit(control, payload) {
        if (control === types_1.ControlActions.Error ||
            control === types_1.ControlActions.GuardViolation) {
            this.logger.error(payload);
        }
        else {
            this.logger.info({ control, payload });
        }
        if (control === types_1.ControlActions.MaxErrorsReached) {
            this.logger.lmsLog({
                inputAction: false,
                input: {},
                isValid: false,
                error: types_1.ControlActions.MaxErrorsReached,
            });
        }
        if (control === types_1.ControlActions.LessonTimedOut) {
            this.lessonComplete();
            this.logger.lmsLog({
                inputAction: false,
                input: {},
                isValid: false,
                error: control,
            });
        }
        this.doEmit({
            type: 'CONTROL',
            payload: {
                control,
                message: payload,
            },
        });
    }
    doActionEmit(payload) {
        if (!payload) {
            return;
        }
        this.doEmit({
            type: 'ACTION',
            payload,
        });
        this.logger.lessonLog({
            inputAction: false,
            input: payload,
        });
        this.logger.lmsLog({
            inputAction: false,
            input: payload,
            isValid: true,
        });
    }
    *doComment(message) {
        if (this.commentsEnabled) {
            yield {
                type: 'comment',
                message,
            };
        }
    }
    doSyncComment(message) {
        if (this.commentsEnabled) {
            this.logger.doLog(Logger_1.LogLevel.INFO, message);
        }
    }
}
exports.default = Extras;
//# sourceMappingURL=data:application/json;base64,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